import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/success.svg'
import _imports_1 from '@/assets/img/icons/set-default-black.svg'


const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { class: "flex flex-col gap-8 align-center items-center p-7" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl text-blue-900 font-semibold" }, " Template berhasil dibuat ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-32 h-32"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-base" }, " Anda bisa mulai menjadikan template tersebut sebagai template default peserta proyek ", -1)
const _hoisted_6 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-semibold" }, "Customize Email", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BModal = _resolveComponent("BModal")!
  const _component_EmailTemplateList = _resolveComponent("EmailTemplateList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BModal, {
      modelValue: _ctx.isShown,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isShown) = $event)),
      id: "success-modal",
      "hide-header": "",
      "hide-footer": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "px-4 py-2 bg-yellow-400 border-1 border-yellow-400 rounded leading-6 text-sm font-semibold flex items-center justify-center gap-3",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDefaultTemplate(_ctx.emailTemplateIdParam)))
            }, [
              _hoisted_7,
              _createTextVNode(" Jadikan Sebagai Template Default ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "px-4 py-2 bg-white border-1 rounded leading-6 text-sm font-semibold text-center",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, " Tutup ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_8,
    _createVNode(_component_EmailTemplateList, {
      data: _ctx.templates,
      "is-loading": _ctx.isLoading,
      "default-template-loading-count": 6,
      "is-addable": "",
      "is-editable": "",
      onSetSelectedTemplate: _ctx.setSelectedTemplate,
      onSetDefaultTemplate: _ctx.setDefaultTemplate,
      onDeleteTemplate: _ctx.deleteTemplate
    }, null, 8, ["data", "is-loading", "onSetSelectedTemplate", "onSetDefaultTemplate", "onDeleteTemplate"])
  ]))
}